export default {
  OPEN: "open",
  Rr: "purchase",
  wr: "push_click",
  xe: "custom_event",
  rm: "iam_click",
  qs: "test",
};
